export type TCardTechnologiesFront = {
  image: string;
  name: string;
};

export const CardTechnologiesFront = ({
  image,
  name
}: TCardTechnologiesFront): JSX.Element => {
  return (
    <div className='card-technologies-front'>
      <img src={image} alt={name} className='image' />
      <p className='name'>{name}</p>
    </div>
  );
};
